// material-ui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project imports
import Logo from 'components/logo';

// ==============================|| MAIN LAYOUT - FOOTER ||============================== //
// CodedThemes/MUI store links removed - not relevant to do-ra.cz.

export default function Footer() {
  return (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 0.625, p: '24px 16px 0px', mt: 'auto', opacity: 0.65 }}>
      <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1 }}>
        &copy;
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', '& svg': { width: 41, height: 8.5 } }}>
        <Logo to="/" />
      </Box>
      <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1 }}>
        2017–{new Date().getFullYear()}
      </Typography>
    </Stack>
  );
}
